import { getSanityAuthTokenFromLocalStorage, sanityConfig } from "@libry-content/common";
import { createClient } from "next-sanity";

// Don't include token here, or client side fetches will include drafts
export const sanityClient = createClient({
  ...sanityConfig,
  useCdn: true,
});

// Client with credentials is used for preview mode
export const clientWithCredidentials = sanityClient.withConfig({
  token: getSanityAuthTokenFromLocalStorage(sanityClient), // Needed for users that are logged in with token in local storage (ie. in Firefox)
  withCredentials: true, // Needed for users that are logged in with cookie (ie. in Chrome)
  useCdn: false, // will be set to false when withCredentials is true, but setting it explicitly removes warnings in console
});

export const getNextFetchRequestConfig = (siteDomain: string, options?: { revalidateInterval?: number }) => ({
  revalidate: options?.revalidateInterval ?? 3600, // Default revalidering (3600) hver time. Skal bli revalidert ved publisering vha on-demand validation, men revaliderer data hver time i tillegg som fallback dersom on-demand validation skulle feile
  tags: [siteDomain], // Bruker siteDomain som cache-tag. Brukes for å kunne invalidere cachen for hele siten i "api/internal/invalidate-next-cache". Skjer ved publisering av innhold i sanity
});
